"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopperCardContent = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("@material-ui/core/styles");
var popper_card_content_styles_1 = require("./popper_card_content_styles");
var useStyles = styles_1.makeStyles(popper_card_content_styles_1.styles);
var PopperCardContentComponent = function (_a) {
    var _b = _a.customClasses, customClasses = _b === void 0 ? {} : _b, children = _a.children;
    var classes = useStyles();
    return react_1.default.createElement("div", { className: classnames_1.default(classes.container, customClasses.container) }, children);
};
exports.PopperCardContent = PopperCardContentComponent;
